module.exports = __webpack_public_path__ + "static/scale-model-of-visit-bakersfield-in-bakersfield-california-684545338f67be90d427ac74b0df759e.png";